//Mock data for AgrarKapital landing page
// Contact Information
export const contactInfo = {
  phone: '08161/18505-50',
  phoneLink: 'tel:+4981611850550',
  email: 'info@agrarkapital.com',
  emailLink: 'mailto:info@agrarkapital.com',
  whatsapp: '0174 8614440',
  whatsappNumber: '491748614440',
  whatsappLink: 'https://wa.me/491748614440?text=' + encodeURIComponent('Hallo Herr Heinrichs, ich möchte meine Fläche einschätzen lassen.\nLandkreis: \nFlächenart (Acker/Wald/Grünland/Hof): \nGröße (ha): \nFlurkarte/Foto schicke ich gleich mit.')
};

// Landkreis Data for Local SEO Pages
export const landkreisData = {
  'freising': {
    name: 'Freising',
    bundesland: 'Bayern',
    vorteile: [
      {
        title: 'Nähe zu München (30 km)',
        description: 'Ideale Lage zwischen Großstadt und ländlichem Raum macht Flächen besonders wertvoll für Investoren und lokale Landwirte.'
      },
      {
        title: 'Hopfenanbaugebiet',
        description: 'Weltbekannte Hallertau sorgt für stabile Nachfrage nach Agrarflächen und überdurchschnittliche Preise.'
      },
      {
        title: 'Flughafen München',
        description: 'Hervorragende Infrastruktur und internationale Anbindung steigern die Attraktivität der Region kontinuierlich.'
      },
      {
        title: 'Technische Universität',
        description: 'Campus Weihenstephan bringt Innovationen in die Landwirtschaft und sichert nachhaltigen Fortschritt.'
      }
    ],
    flächenarten: {
      'wald': {
        title: 'Wald verkaufen im Landkreis Freising',
        subtitle: 'Professionelle Vermarktung von Waldflächen mit 15+ Jahren Erfahrung in der Region',
        art: 'Wald',
        metaDescription: 'Wald verkaufen im Landkreis Freising mit AgrarKapital. Durchschnittspreis 12.500€/ha. Schnelle Vermarktung in Ø 4,2 Monaten',
        durchschnittspreis: '12.500€/ha',
        verkaufsdauer: 'Ø 4,2 Monate',
        verkaufteFlächen: '23,4 ha',
        nachfrage: 'Sehr hoch',
        hauptkäufer: '70% lokale Landwirte',
        preissteigerung: '18%',
        preisentwicklungText: 'Kontinuierliche Wertsteigerung durch München-Nähe und Klimawandel-Aufforstungstrends.',
        käuferNachfrage: 'Hoch',
        käuferStruktur: '70% regionale Betriebe, 20% Privatinvestoren, 10% institutionelle Käufer',
        verkaufsgeschwindigkeitText: '15% schneller als Bayernschnitt durch aktives Käufernetzwerk vor Ort.',
        kundenstimme: 'Andreas hat den besten Preis für meinen Wald geholt. Professionell von der Bewertung bis zum Notar.',
        erfolgsgeschichten: [
          {
            titel: '5,2 ha Mischwald in Freising-Ost',
            details: 'Verkaufspreis: 65.000€ | Verkaufsdauer: 3 Monate',
            erfolg: 'Käufer: Lokaler Landwirtschaftsbetrieb'
          },
          {
            titel: '12,8 ha Fichtenbestand in Wang',
            details: 'Verkaufspreis: 156.000€ | Verkaufsdauer: 5 Monate',
            erfolg: 'Käufer: Privatinvestor aus München'
          }
        ],
        faq: [
          {
            frage: 'Welche Genehmigungen brauche ich für den Waldverkauf in Freising?',
            antwort: 'In Bayern benötigen Sie keine besonderen Genehmigungen für den Waldverkauf. Wir prüfen vorab alle rechtlichen Aspekte wie Vorkaufsrechte und begleiten Sie sicher durch den gesamten Prozess.'
          },
          {
            frage: 'Wie wird der Waldwert in Freising ermittelt?',
            antwort: 'Wir bewerten nach Baumarten, Alter, Bonität und Erschließung. Besonders wertvoll sind erschlossene Bestände in München-Nähe. Unsere Expertise im Landkreis sorgt für marktgerechte Preise.'
          },
          {
            frage: 'Zahle ich Spekulationssteuer beim Waldverkauf?',
            antwort: 'Wald ist von der Spekulationssteuer befreit, wenn er forstwirtschaftlich genutzt wurde. Wir beraten Sie zu allen steuerlichen Aspekten und vermitteln bei Bedarf Steuerexperten.'
          },
          {
            frage: 'Wie lange dauert der Verkaufsprozess in Freising?',
            antwort: 'Durchschnittlich 4,2 Monate von der Bewertung bis zum Notartermin. Durch unser aktives Käufernetzwerk vor Ort verkaufen wir 15% schneller als der Bayernschnitt.'
          }
        ]
      },
      'ackerland': {
        title: 'Ackerland verkaufen im Landkreis Freising',
        subtitle: 'Höchste Preise für Ihre Ackerflächen durch lokale Marktkenntnis und Käufernetzwerk',
        art: 'Ackerland',
        metaDescription: 'Ackerland verkaufen im Landkreis Freising mit AgrarKapital. Durchschnittspreis 45.000€/ha. Premium-Böden der Hallertau',
        durchschnittspreis: '45.000€/ha',
        verkaufsdauer: 'Ø 3,8 Monate',
        verkaufteFlächen: '156,7 ha',
        nachfrage: 'Extrem hoch',
        hauptkäufer: '85% Landwirtschaftsbetriebe',
        preissteigerung: '24%',
        preisentwicklungText: 'Hopfenanbaugebiet und München-Nähe treiben Preise kontinuierlich nach oben.',
        käuferNachfrage: 'Extrem hoch',
        käuferStruktur: '85% regionale Betriebe, 10% Agrarbetriebe aus anderen Landkreisen, 5% Investoren',
        verkaufsgeschwindigkeitText: 'Schnellste Vermarktung in Bayern durch hohe Nachfrage und unser Netzwerk.',
        kundenstimme: 'Unfassbar - 20% mehr als erhofft! AgrarKapital kennt jeden Betrieb in Freising.',
        erfolgsgeschichten: [
          {
            titel: '8,4 ha Hopfenacker bei Wolfersdorf',
            details: 'Verkaufspreis: 420.000€ | Verkaufsdauer: 2 Monate',
            erfolg: 'Käufer: Hopfenbaubetrieb aus der Region'
          },
          {
            titel: '15,2 ha Getreideacker bei Marzling',
            details: 'Verkaufspreis: 685.000€ | Verkaufsdauer: 4 Monate',
            erfolg: 'Käufer: Landwirtschaftsbetrieb aus dem Nachbarlandkreis'
          }
        ],
        faq: [
          {
            frage: 'Was macht Ackerland in Freising so wertvoll?',
            antwort: 'Die Hallertau ist das weltgrößte zusammenhängende Hopfenanbaugebiet. Kombiniert mit der München-Nähe und erstklassigen Böden entstehen Deutschlands höchste Ackerpreise.'
          },
          {
            frage: 'Brauche ich eine Verkaufsgenehmigung in Bayern?',
            antwort: 'Nein, in Bayern gibt es keine Genehmigungspflicht für Landverkäufe. Wir prüfen jedoch Vorkaufsrechte und begleiten Sie rechtssicher durch den gesamten Prozess.'
          },
          {
            frage: 'Wie schnell kann ich mein Ackerland verkaufen?',
            antwort: 'Im Durchschnitt 3,8 Monate. Durch die extrem hohe Nachfrage in Freising und unser Käufernetzwerk oft deutlich schneller - manchmal schon nach wenigen Wochen.'
          },
          {
            frage: 'Welche Unterlagen brauche ich für den Verkauf?',
            antwort: 'Grundbuchauszug, Flurkarte, Bodenbonitierung und eventuelle Pachtverträge. Wir unterstützen Sie bei der Beschaffung aller notwendigen Dokumente.'
          }
        ]
      },
      'gruenland': {
        title: 'Grünland verkaufen im Landkreis Freising',
        subtitle: 'Weideland und Wiesen professionell vermarkten - faire Preise durch lokale Expertise',
        art: 'Grünland',
        metaDescription: 'Grünland verkaufen im Landkreis Freising mit AgrarKapital. Durchschnittspreis 32.000€/ha. Weideland und Wiesen professionell vermarkten',
        durchschnittspreis: '32.000€/ha',
        verkaufsdauer: 'Ø 5,1 Monate',
        verkaufteFlächen: '89,3 ha',
        nachfrage: 'Hoch',
        hauptkäufer: '80% Milchviehbetriebe',
        preissteigerung: '16%',
        preisentwicklungText: 'Steigende Bio-Nachfrage und Extensivierungstrends sorgen für stabile Wertentwicklung.',
        käuferNachfrage: 'Hoch',
        käuferStruktur: '80% Milchvieh- und Rinderbetriebe, 15% Pferdehöfe, 5% Biolandwirte',
        verkaufsgeschwindigkeitText: 'Solide Vermarktung durch etablierte Betriebe in der milchviehstarken Region.',
        kundenstimme: 'Faire Bewertung und schnelle Abwicklung. Genau die richtige Zielgruppe gefunden.',
        erfolgsgeschichten: [
          {
            titel: '12,7 ha Dauergrünland bei Zolling',
            details: 'Verkaufspreis: 395.000€ | Verkaufsdauer: 4 Monate',
            erfolg: 'Käufer: Milchviehbetrieb aus Freising'
          },
          {
            titel: '6,8 ha Weide in Kirchdorf',
            details: 'Verkaufspreis: 210.000€ | Verkaufsdauer: 6 Monate',
            erfolg: 'Käufer: Pferdehof aus der Region'
          }
        ],
        faq: [
          {
            frage: 'Ist Grünland in Freising gefragt?',
            antwort: 'Ja, besonders von Milchviehbetrieben und Pferdehöfen. Die Region hat viele spezialisierte Betriebe, die kontinuierlich Flächen zur Arrondierung suchen.'
          },
          {
            frage: 'Was beeinflusst den Grünlandpreis?',
            antwort: 'Entscheidend sind Lage, Erschließung, Hangneigung und Bodenpunkte. Ebene, gut erschlossene Flächen in Hofnähe erzielen die höchsten Preise.'
          },
          {
            frage: 'Muss ich Pachtverträge kündigen?',
            antwort: 'Nicht zwingend. Viele Käufer übernehmen bestehende Pachten oder wir finden Lösungen für alle Parteien. Wir beraten Sie zu allen Optionen.'
          },
          {
            frage: 'Gibt es Förderungen für Grünlandkäufer?',
            antwort: 'Ja, verschiedene Programme unterstützen Junglandwirte und Betriebserweiterungen. Wir informieren Käufer über alle Möglichkeiten.'
          }
        ]
      }
    }
  },
  'muenchen-land': {
    name: 'München (Landkreis)',
    bundesland: 'Bayern',
    vorteile: [
      {
        title: 'Direkter München-Speckgürtel',
        description: 'Höchste Wertsteigerungspotentiale durch kontinuierliche Stadtentwicklung und Bevölkerungswachstum.'
      },
      {
        title: 'Premium-Infrastruktur',
        description: 'S-Bahn-Anbindung, Autobahnen und erstklassige Erschließung machen jede Fläche wertvoll.'
      },
      {
        title: 'Wohlhabende Käuferschicht',
        description: 'Hohe Kaufkraft der Münchner Bürger sorgt für stabile Nachfrage und Rekordpreise.'
      },
      {
        title: 'Knappheit treibt Preise',
        description: 'Begrenzte Verfügbarkeit bei hoher Nachfrage führt zu kontinuierlichen Wertsteigerungen.'
      }
    ],
    flächenarten: {
      'wald': {
        title: 'Wald verkaufen im Landkreis München',
        subtitle: 'Bayerns wertvollste Waldflächen - Rekordpreise durch München-Nähe',
        art: 'Wald',
        metaDescription: 'Wald verkaufen Landkreis München mit AgrarKapital. Durchschnittspreis 18.500€/ha. München-Speckgürtel mit Rekordpreisen',
        durchschnittspreis: '18.500€/ha',
        verkaufsdauer: 'Ø 3,2 Monate',
        verkaufteFlächen: '31,2 ha',
        nachfrage: 'Extrem hoch',
        hauptkäufer: '60% Privatinvestoren',
        preissteigerung: '32%',
        preisentwicklungText: 'München-Nähe und Investorendruck sorgen für Bayerns höchste Waldpreise.',
        käuferNachfrage: 'Extrem hoch',
        käuferStruktur: '60% Privatinvestoren, 30% lokale Betriebe, 10% institutionelle Anleger',
        verkaufsgeschwindigkeitText: 'Schnellste Waldvermarktung Deutschlands durch enormen Investorendruck.',
        kundenstimme: 'Wahnsinn! Doppelt so viel bekommen wie gedacht. AgrarKapital kennt die richtigen Käufer.',
        erfolgsgeschichten: [
          {
            titel: '3,8 ha Mischwald bei Gräfelfing',
            details: 'Verkaufspreis: 95.000€ | Verkaufsdauer: 2 Monate',
            erfolg: 'Käufer: Münchner Privatinvestor'
          },
          {
            titel: '9,4 ha Fichtenwald bei Pullach',
            details: 'Verkaufspreis: 205.000€ | Verkaufsdauer: 3 Monate',
            erfolg: 'Käufer: Investmentgesellschaft'
          }
        ],
        faq: [
          {
            frage: 'Warum sind Waldpreise um München so hoch?',
            antwort: 'München-Nähe, hohe Kaufkraft, Knappheit und Klimawandel-Trends treiben Investoren in Waldflächen. Rekordpreise sind die Folge.'
          },
          {
            frage: 'Wer kauft Wald um München?',
            antwort: '60% Privatinvestoren aus München, 30% lokale Betriebe, 10% institutionelle Anleger. Alle suchen wertstabile Anlagen.'
          },
          {
            frage: 'Wie schnell kann ich verkaufen?',
            antwort: 'Durchschnittlich 3,2 Monate - oft deutlich schneller. Die Nachfrage ist so hoch, dass wir teilweise Wartelisten haben.'
          },
          {
            frage: 'Gibt es Risiken bei hohen Preisen?',
            antwort: 'Der Markt ist robust. München wächst weiter, Flächen werden knapper. Wir vermitteln nur seriöse, finanzstarke Käufer.'
          }
        ]
      },
      'ackerland': {
        title: 'Ackerland verkaufen im Landkreis München',
        subtitle: 'Deutschlands teuerste Ackerflächen - Spitzenpreise im München-Speckgürtel',
        art: 'Ackerland',
        metaDescription: 'Ackerland verkaufen Landkreis München mit AgrarKapital. Durchschnittspreis 85.000€/ha. Deutschlands höchste Ackerpreise',
        durchschnittspreis: '85.000€/ha',
        verkaufsdauer: 'Ø 2,8 Monate',
        verkaufteFlächen: '67,3 ha',
        nachfrage: 'Extrem hoch',
        hauptkäufer: '50% Investoren, 50% Betriebe',
        preissteigerung: '41%',
        preisentwicklungText: 'Deutschlands höchste Ackerpreise durch München-Speckgürtel und Flächenknappheit.',
        käuferNachfrage: 'Extrem hoch',
        käuferStruktur: '50% Investoren und vermögende Privatpersonen, 50% spezialisierte Agrarbetriebe',
        verkaufsgeschwindigkeitText: 'Rekordgeschwindigkeit durch enormen Nachfrageüberhang und unser Premiumkäufer-Netzwerk.',
        kundenstimme: 'Unglaublich! 85.000€ pro Hektar - mehr als je erträumt. Perfekte Beratung von AgrarKapital.',
        erfolgsgeschichten: [
          {
            titel: '4,2 ha Acker bei Germering',
            details: 'Verkaufspreis: 380.000€ | Verkaufsdauer: 2 Monate',
            erfolg: 'Käufer: Münchner Unternehmer'
          },
          {
            titel: '11,8 ha Premium-Acker Neuried',
            details: 'Verkaufspreis: 1.180.000€ | Verkaufsdauer: 3 Monate',
            erfolg: 'Käufer: Spezialisierter Ackerbaubetrieb'
          }
        ],
        faq: [
          {
            frage: 'Warum 85.000€/ha um München?',
            antwort: 'München-Speckgürtel, Flächenknappheit, Investorendruck und Wertsteigerungserwartungen führen zu Deutschlands Spitzenpreisen.'
          },
          {
            frage: 'Wer zahlt solche Preise?',
            antwort: '50% vermögende Investoren aus München, 50% hochspezialisierte Betriebe. Alle sehen langfristigen Wert.'
          },
          {
            frage: 'Ist das nachhaltig?',
            antwort: 'München wächst weiter, Flächen werden knapper. Die Preisdynamik ist durch Fundamentaldaten gerechtfertigt.'
          },
          {
            frage: 'Wie finde ich den besten Käufer?',
            antwort: 'Durch unser Premium-Netzwerk erreichen wir sowohl Investoren als auch Betriebe und erzielen Höchstpreise für Sie.'
          }
        ]
      },
      'gruenland': {
        title: 'Grünland verkaufen im Landkreis München',
        subtitle: 'Premium-Grünland im München-Speckgürtel - außergewöhnliche Wertsteigerung',
        art: 'Grünland',
        metaDescription: 'Grünland verkaufen Landkreis München mit AgrarKapital. Durchschnittspreis 55.000€/ha. München-Speckgürtel Premium-Preise',
        durchschnittspreis: '55.000€/ha',
        verkaufsdauer: 'Ø 3,5 Monate',
        verkaufteFlächen: '43,8 ha',
        nachfrage: 'Sehr hoch',
        hauptkäufer: '70% Investoren',
        preissteigerung: '28%',
        preisentwicklungText: 'München-Nähe und Investoreninteresse treiben Grünlandpreise auf Rekordniveau.',
        käuferNachfrage: 'Sehr hoch',
        käuferStruktur: '70% Investoren und Privatpersonen, 20% Pferdehöfe, 10% Landwirtschaftsbetriebe',
        verkaufsgeschwindigkeitText: 'Überdurchschnittlich schnell durch hohe Kaufkraft der Münchner Käuferschicht.',
        kundenstimme: 'Hätte nie gedacht, dass meine Wiese so wertvoll ist. AgrarKapital hat den perfekten Käufer gefunden.',
        erfolgsgeschichten: [
          {
            titel: '7,3 ha Grünland bei Planegg',
            details: 'Verkaufspreis: 425.000€ | Verkaufsdauer: 3 Monate',
            erfolg: 'Käufer: Münchner Privatinvestor'
          },
          {
            titel: '12,1 ha Weide bei Garching',
            details: 'Verkaufspreis: 680.000€ | Verkaufsdauer: 4 Monate',
            erfolg: 'Käufer: Pferdehof mit München-Anbindung'
          }
        ],
        faq: [
          {
            frage: 'Warum ist Grünland um München so teuer?',
            antwort: 'München-Nähe macht jede Fläche wertvoll. Investoren, Pferdehöfe und vermögende Privatpersonen konkurrieren um knappe Flächen.'
          },
          {
            frage: 'Wer kauft Grünland für 55.000€/ha?',
            antwort: 'Hauptsächlich Münchner Investoren (70%), Pferdehöfe mit München-Bezug (20%) und spezialisierte Betriebe (10%).'
          },
          {
            frage: 'Lohnt sich das Investment für Käufer?',
            antwort: 'München wächst kontinuierlich. Flächen im Speckgürtel gelten als wertstabile Anlage mit Wertsteigerungspotential.'
          },
          {
            frage: 'Wie finde ich den zahlkräftigsten Käufer?',
            antwort: 'Unser München-Netzwerk umfasst Investoren, Unternehmer und spezialisierte Betriebe. Wir finden den Bestbieter.'
          }
        ]
      }
    }
  }
  // Weitere 18 Landkreise werden hier hinzugefügt...
};

// German states (Bundesländer)
export const germanStates = [
  'Baden-Württemberg',
  'Bayern',
  'Berlin',
  'Brandenburg',
  'Bremen',
  'Hamburg',
  'Hessen',
  'Mecklenburg-Vorpommern',
  'Niedersachsen',
  'Nordrhein-Westfalen',
  'Rheinland-Pfalz',
  'Saarland',
  'Sachsen',
  'Sachsen-Anhalt',
  'Schleswig-Holstein',
  'Thüringen'
];

// Mock counties by state (complete list of all 401 German districts)
export const countiesByState = {
  'Baden-Württemberg': [
    { name: 'Stuttgart', status: 'live' },
    { name: 'Böblingen', status: 'live' },
    { name: 'Esslingen', status: 'live' },
    { name: 'Göppingen', status: 'beta' },
    { name: 'Ludwigsburg', status: 'live' },
    { name: 'Rems-Murr-Kreis', status: 'live' },
    { name: 'Heilbronn (Stadt)', status: 'live' },
    { name: 'Heilbronn (Landkreis)', status: 'beta' },
    { name: 'Hohenlohekreis', status: 'beta' },
    { name: 'Schwäbisch Hall', status: 'beta' },
    { name: 'Main-Tauber-Kreis', status: 'beta' },
    { name: 'Heidenheim', status: 'beta' },
    { name: 'Ostalbkreis', status: 'beta' },
    { name: 'Baden-Baden', status: 'live' },
    { name: 'Karlsruhe (Stadt)', status: 'live' },
    { name: 'Karlsruhe (Landkreis)', status: 'live' },
    { name: 'Rastatt', status: 'live' },
    { name: 'Heidelberg', status: 'live' },
    { name: 'Mannheim', status: 'live' },
    { name: 'Neckar-Odenwald-Kreis', status: 'beta' },
    { name: 'Rhein-Neckar-Kreis', status: 'live' },
    { name: 'Pforzheim', status: 'live' },
    { name: 'Calw', status: 'beta' },
    { name: 'Enzkreis', status: 'beta' },
    { name: 'Freudenstadt', status: 'beta' },
    { name: 'Freiburg im Breisgau', status: 'live' },
    { name: 'Breisgau-Hochschwarzwald', status: 'live' },
    { name: 'Emmendingen', status: 'beta' },
    { name: 'Ortenaukreis', status: 'beta' },
    { name: 'Rottweil', status: 'beta' },
    { name: 'Schwarzwald-Baar-Kreis', status: 'beta' },
    { name: 'Tuttlingen', status: 'beta' },
    { name: 'Konstanz', status: 'live' },
    { name: 'Lörrach', status: 'beta' },
    { name: 'Waldshut', status: 'beta' },
    { name: 'Reutlingen', status: 'beta' },
    { name: 'Tübingen', status: 'live' },
    { name: 'Zollernalbkreis', status: 'beta' },
    { name: 'Ulm', status: 'live' },
    { name: 'Alb-Donau-Kreis', status: 'beta' },
    { name: 'Biberach', status: 'beta' },
    { name: 'Bodenseekreis', status: 'live' },
    { name: 'Ravensburg', status: 'beta' },
    { name: 'Sigmaringen', status: 'beta' }
  ],
  'Bayern': [
    { name: 'München (Stadt)', status: 'live' },
    { name: 'München (Landkreis)', status: 'live' },
    { name: 'Altötting', status: 'beta' },
    { name: 'Berchtesgadener Land', status: 'live' },
    { name: 'Bad Tölz-Wolfratshausen', status: 'beta' },
    { name: 'Dachau', status: 'live' },
    { name: 'Ebersberg', status: 'live' },
    { name: 'Eichstätt', status: 'beta' },
    { name: 'Erding', status: 'live' },
    { name: 'Freising', status: 'live' },
    { name: 'Fürstenfeldbruck', status: 'live' },
    { name: 'Garmisch-Partenkirchen', status: 'live' },
    { name: 'Landsberg am Lech', status: 'beta' },
    { name: 'Miesbach', status: 'beta' },
    { name: 'Mühldorf am Inn', status: 'beta' },
    { name: 'Neuburg-Schrobenhausen', status: 'beta' },
    { name: 'Pfaffenhofen an der Ilm', status: 'beta' },
    { name: 'Rosenheim (Stadt)', status: 'live' },
    { name: 'Rosenheim (Landkreis)', status: 'live' },
    { name: 'Starnberg', status: 'live' },
    { name: 'Traunstein', status: 'beta' },
    { name: 'Weilheim-Schongau', status: 'beta' },
    { name: 'Ingolstadt', status: 'live' },
    { name: 'Kelheim', status: 'beta' },
    { name: 'Landshut (Stadt)', status: 'beta' },
    { name: 'Landshut (Landkreis)', status: 'beta' },
    { name: 'Passau (Stadt)', status: 'beta' },
    { name: 'Passau (Landkreis)', status: 'beta' },
    { name: 'Rottal-Inn', status: 'beta' },
    { name: 'Straubing', status: 'beta' },
    { name: 'Straubing-Bogen', status: 'beta' },
    { name: 'Deggendorf', status: 'beta' },
    { name: 'Freyung-Grafenau', status: 'beta' },
    { name: 'Regen', status: 'beta' },
    { name: 'Dingolfing-Landau', status: 'beta' },
    { name: 'Amberg', status: 'beta' },
    { name: 'Amberg-Sulzbach', status: 'beta' },
    { name: 'Cham', status: 'beta' },
    { name: 'Neumarkt in der Oberpfalz', status: 'beta' },
    { name: 'Neustadt an der Waldnaab', status: 'beta' },
    { name: 'Regensburg (Stadt)', status: 'live' },
    { name: 'Regensburg (Landkreis)', status: 'live' },
    { name: 'Schwandorf', status: 'beta' },
    { name: 'Tirschenreuth', status: 'beta' },
    { name: 'Weiden in der Oberpfalz', status: 'beta' },
    { name: 'Bamberg (Stadt)', status: 'live' },
    { name: 'Bamberg (Landkreis)', status: 'live' },
    { name: 'Bayreuth (Stadt)', status: 'beta' },
    { name: 'Bayreuth (Landkreis)', status: 'beta' },
    { name: 'Coburg (Stadt)', status: 'beta' },
    { name: 'Coburg (Landkreis)', status: 'beta' },
    { name: 'Forchheim', status: 'beta' },
    { name: 'Hof (Stadt)', status: 'beta' },
    { name: 'Hof (Landkreis)', status: 'beta' },
    { name: 'Kronach', status: 'beta' },
    { name: 'Kulmbach', status: 'beta' },
    { name: 'Lichtenfels', status: 'beta' },
    { name: 'Wunsiedel im Fichtelgebirge', status: 'beta' },
    { name: 'Ansbach (Stadt)', status: 'beta' },
    { name: 'Ansbach (Landkreis)', status: 'beta' },
    { name: 'Erlangen', status: 'live' },
    { name: 'Erlangen-Höchstadt', status: 'live' },
    { name: 'Fürth (Stadt)', status: 'live' },
    { name: 'Fürth (Landkreis)', status: 'live' },
    { name: 'Nürnberger Land', status: 'live' },
    { name: 'Nürnberg', status: 'live' },
    { name: 'Neustadt an der Aisch-Bad Windsheim', status: 'beta' },
    { name: 'Roth', status: 'beta' },
    { name: 'Weißenburg-Gunzenhausen', status: 'beta' },
    { name: 'Aschaffenburg (Stadt)', status: 'beta' },
    { name: 'Aschaffenburg (Landkreis)', status: 'beta' },
    { name: 'Bad Kissingen', status: 'beta' },
    { name: 'Rhön-Grabfeld', status: 'beta' },
    { name: 'Haßberge', status: 'beta' },
    { name: 'Kitzingen', status: 'beta' },
    { name: 'Miltenberg', status: 'beta' },
    { name: 'Main-Spessart', status: 'beta' },
    { name: 'Schweinfurt (Stadt)', status: 'beta' },
    { name: 'Schweinfurt (Landkreis)', status: 'beta' },
    { name: 'Würzburg (Stadt)', status: 'live' },
    { name: 'Würzburg (Landkreis)', status: 'live' },
    { name: 'Augsburg (Stadt)', status: 'live' },
    { name: 'Augsburg (Landkreis)', status: 'live' },
    { name: 'Aichach-Friedberg', status: 'beta' },
    { name: 'Dillingen an der Donau', status: 'beta' },
    { name: 'Günzburg', status: 'beta' },
    { name: 'Neu-Ulm', status: 'beta' },
    { name: 'Lindau (Bodensee)', status: 'live' },
    { name: 'Ostallgäu', status: 'beta' },
    { name: 'Unterallgäu', status: 'beta' },
    { name: 'Donau-Ries', status: 'beta' },
    { name: 'Oberallgäu', status: 'beta' },
    { name: 'Kempten (Allgäu)', status: 'beta' },
    { name: 'Kaufbeuren', status: 'beta' },
    { name: 'Memmingen', status: 'beta' }
  ],
  'Berlin': [
    { name: 'Berlin', status: 'live' }
  ],
  'Brandenburg': [
    { name: 'Brandenburg an der Havel', status: 'live' },
    { name: 'Cottbus', status: 'live' },
    { name: 'Frankfurt (Oder)', status: 'beta' },
    { name: 'Potsdam', status: 'live' },
    { name: 'Barnim', status: 'beta' },
    { name: 'Dahme-Spreewald', status: 'beta' },
    { name: 'Elbe-Elster', status: 'beta' },
    { name: 'Havelland', status: 'beta' },
    { name: 'Märkisch-Oderland', status: 'beta' },
    { name: 'Oberhavel', status: 'live' },
    { name: 'Oberspreewald-Lausitz', status: 'beta' },
    { name: 'Oder-Spree', status: 'beta' },
    { name: 'Ostprignitz-Ruppin', status: 'beta' },
    { name: 'Potsdam-Mittelmark', status: 'live' },
    { name: 'Prignitz', status: 'beta' },
    { name: 'Spree-Neiße', status: 'beta' },
    { name: 'Teltow-Fläming', status: 'beta' },
    { name: 'Uckermark', status: 'beta' }
  ],
  'Bremen': [
    { name: 'Bremen', status: 'live' },
    { name: 'Bremerhaven', status: 'beta' }
  ],
  'Hamburg': [
    { name: 'Hamburg', status: 'live' }
  ],
  'Hessen': [
    { name: 'Darmstadt', status: 'live' },
    { name: 'Frankfurt am Main', status: 'live' },
    { name: 'Offenbach am Main', status: 'live' },
    { name: 'Wiesbaden', status: 'live' },
    { name: 'Bergstraße', status: 'beta' },
    { name: 'Darmstadt-Dieburg', status: 'live' },
    { name: 'Groß-Gerau', status: 'live' },
    { name: 'Hochtaunuskreis', status: 'live' },
    { name: 'Main-Kinzig-Kreis', status: 'beta' },
    { name: 'Main-Taunus-Kreis', status: 'live' },
    { name: 'Odenwaldkreis', status: 'beta' },
    { name: 'Offenbach (Landkreis)', status: 'live' },
    { name: 'Rheingau-Taunus-Kreis', status: 'beta' },
    { name: 'Wetteraukreis', status: 'beta' },
    { name: 'Gießen', status: 'live' },
    { name: 'Lahn-Dill-Kreis', status: 'beta' },
    { name: 'Limburg-Weilburg', status: 'beta' },
    { name: 'Marburg-Biedenkopf', status: 'live' },
    { name: 'Vogelsbergkreis', status: 'beta' },
    { name: 'Kassel (Stadt)', status: 'live' },
    { name: 'Fulda', status: 'beta' },
    { name: 'Hersfeld-Rotenburg', status: 'beta' },
    { name: 'Kassel (Landkreis)', status: 'live' },
    { name: 'Schwalm-Eder-Kreis', status: 'beta' },
    { name: 'Waldeck-Frankenberg', status: 'beta' },
    { name: 'Werra-Meißner-Kreis', status: 'beta' }
  ],
  'Mecklenburg-Vorpommern': [
    { name: 'Rostock (Stadt)', status: 'beta' },
    { name: 'Schwerin', status: 'beta' },
    { name: 'Ludwigslust-Parchim', status: 'beta' },
    { name: 'Nordwestmecklenburg', status: 'beta' },
    { name: 'Rostock (Landkreis)', status: 'beta' },
    { name: 'Mecklenburgische Seenplatte', status: 'beta' },
    { name: 'Vorpommern-Rügen', status: 'beta' },
    { name: 'Vorpommern-Greifswald', status: 'beta' }
  ],
  'Niedersachsen': [
    { name: 'Braunschweig', status: 'live' },
    { name: 'Salzgitter', status: 'beta' },
    { name: 'Wolfsburg', status: 'live' },
    { name: 'Gifhorn', status: 'beta' },
    { name: 'Goslar', status: 'beta' },
    { name: 'Helmstedt', status: 'beta' },
    { name: 'Northeim', status: 'beta' },
    { name: 'Peine', status: 'beta' },
    { name: 'Wolfenbüttel', status: 'beta' },
    { name: 'Göttingen', status: 'live' },
    { name: 'Hannover (Region)', status: 'live' },
    { name: 'Diepholz', status: 'beta' },
    { name: 'Hameln-Pyrmont', status: 'beta' },
    { name: 'Hildesheim', status: 'live' },
    { name: 'Holzminden', status: 'beta' },
    { name: 'Nienburg (Weser)', status: 'beta' },
    { name: 'Schaumburg', status: 'beta' },
    { name: 'Celle', status: 'beta' },
    { name: 'Cuxhaven', status: 'beta' },
    { name: 'Harburg', status: 'live' },
    { name: 'Lüchow-Dannenberg', status: 'beta' },
    { name: 'Lüneburg', status: 'beta' },
    { name: 'Osterholz', status: 'beta' },
    { name: 'Rotenburg (Wümme)', status: 'beta' },
    { name: 'Heidekreis', status: 'beta' },
    { name: 'Stade', status: 'beta' },
    { name: 'Uelzen', status: 'beta' },
    { name: 'Verden', status: 'beta' },
    { name: 'Delmenhorst', status: 'beta' },
    { name: 'Emden', status: 'beta' },
    { name: 'Oldenburg (Stadt)', status: 'live' },
    { name: 'Osnabrück (Stadt)', status: 'live' },
    { name: 'Wilhelmshaven', status: 'beta' },
    { name: 'Ammerland', status: 'beta' },
    { name: 'Aurich', status: 'beta' },
    { name: 'Cloppenburg', status: 'beta' },
    { name: 'Emsland', status: 'beta' },
    { name: 'Friesland', status: 'beta' },
    { name: 'Grafschaft Bentheim', status: 'beta' },
    { name: 'Leer', status: 'beta' },
    { name: 'Oldenburg (Landkreis)', status: 'beta' },
    { name: 'Osnabrück (Landkreis)', status: 'beta' },
    { name: 'Vechta', status: 'beta' },
    { name: 'Wesermarsch', status: 'beta' },
    { name: 'Wittmund', status: 'beta' }
  ],
  'Nordrhein-Westfalen': [
    { name: 'Düsseldorf', status: 'live' },
    { name: 'Duisburg', status: 'live' },
    { name: 'Essen', status: 'live' },
    { name: 'Krefeld', status: 'live' },
    { name: 'Mönchengladbach', status: 'live' },
    { name: 'Mülheim an der Ruhr', status: 'live' },
    { name: 'Oberhausen', status: 'beta' },
    { name: 'Remscheid', status: 'beta' },
    { name: 'Solingen', status: 'beta' },
    { name: 'Wuppertal', status: 'live' },
    { name: 'Kleve', status: 'beta' },
    { name: 'Mettmann', status: 'live' },
    { name: 'Rhein-Kreis Neuss', status: 'live' },
    { name: 'Viersen', status: 'beta' },
    { name: 'Wesel', status: 'beta' },
    { name: 'Bonn', status: 'live' },
    { name: 'Köln', status: 'live' },
    { name: 'Leverkusen', status: 'live' },
    { name: 'Städteregion Aachen', status: 'live' },
    { name: 'Düren', status: 'beta' },
    { name: 'Erftkreis', status: 'live' },
    { name: 'Euskirchen', status: 'beta' },
    { name: 'Heinsberg', status: 'beta' },
    { name: 'Oberbergischer Kreis', status: 'beta' },
    { name: 'Rheinisch-Bergischer Kreis', status: 'beta' },
    { name: 'Rhein-Erft-Kreis', status: 'live' },
    { name: 'Rhein-Sieg-Kreis', status: 'live' },
    { name: 'Bottrop', status: 'beta' },
    { name: 'Gelsenkirchen', status: 'beta' },
    { name: 'Münster', status: 'live' },
    { name: 'Borken', status: 'beta' },
    { name: 'Coesfeld', status: 'beta' },
    { name: 'Recklinghausen', status: 'beta' },
    { name: 'Steinfurt', status: 'beta' },
    { name: 'Warendorf', status: 'beta' },
    { name: 'Bielefeld', status: 'live' },
    { name: 'Gütersloh', status: 'beta' },
    { name: 'Herford', status: 'beta' },
    { name: 'Höxter', status: 'beta' },
    { name: 'Lippe', status: 'beta' },
    { name: 'Minden-Lübbecke', status: 'beta' },
    { name: 'Paderborn', status: 'beta' },
    { name: 'Bochum', status: 'live' },
    { name: 'Dortmund', status: 'live' },
    { name: 'Hagen', status: 'beta' },
    { name: 'Hamm', status: 'beta' },
    { name: 'Herne', status: 'beta' },
    { name: 'Ennepe-Ruhr-Kreis', status: 'beta' },
    { name: 'Hochsauerlandkreis', status: 'beta' },
    { name: 'Märkischer Kreis', status: 'beta' },
    { name: 'Olpe', status: 'beta' },
    { name: 'Siegen-Wittgenstein', status: 'beta' },
    { name: 'Soest', status: 'beta' },
    { name: 'Unna', status: 'beta' }
  ],
  'Rheinland-Pfalz': [
    { name: 'Koblenz', status: 'live' },
    { name: 'Ahrweiler', status: 'beta' },
    { name: 'Altenkirchen (Westerwald)', status: 'beta' },
    { name: 'Bad Kreuznach', status: 'beta' },
    { name: 'Birkenfeld', status: 'beta' },
    { name: 'Cochem-Zell', status: 'beta' },
    { name: 'Mayen-Koblenz', status: 'beta' },
    { name: 'Neuwied', status: 'beta' },
    { name: 'Rhein-Hunsrück-Kreis', status: 'beta' },
    { name: 'Rhein-Lahn-Kreis', status: 'beta' },
    { name: 'Westerwaldkreis', status: 'beta' },
    { name: 'Trier', status: 'live' },
    { name: 'Bernkastel-Wittlich', status: 'beta' },
    { name: 'Eifelkreis Bitburg-Prüm', status: 'beta' },
    { name: 'Vulkaneifel', status: 'beta' },
    { name: 'Trier-Saarburg', status: 'beta' },
    { name: 'Frankenthal (Pfalz)', status: 'beta' },
    { name: 'Kaiserslautern (Stadt)', status: 'beta' },
    { name: 'Landau in der Pfalz', status: 'beta' },
    { name: 'Ludwigshafen am Rhein', status: 'live' },
    { name: 'Mainz', status: 'live' },
    { name: 'Neustadt an der Weinstraße', status: 'beta' },
    { name: 'Pirmasens', status: 'beta' },
    { name: 'Speyer', status: 'beta' },
    { name: 'Worms', status: 'beta' },
    { name: 'Zweibrücken', status: 'beta' },
    { name: 'Alzey-Worms', status: 'beta' },
    { name: 'Bad Dürkheim', status: 'beta' },
    { name: 'Donnersbergkreis', status: 'beta' },
    { name: 'Germersheim', status: 'beta' },
    { name: 'Kaiserslautern (Landkreis)', status: 'beta' },
    { name: 'Kusel', status: 'beta' },
    { name: 'Südliche Weinstraße', status: 'beta' },
    { name: 'Rhein-Pfalz-Kreis', status: 'beta' },
    { name: 'Mainz-Bingen', status: 'live' },
    { name: 'Südwestpfalz', status: 'beta' }
  ],
  'Saarland': [
    { name: 'Stadtverband Saarbrücken', status: 'live' },
    { name: 'Merzig-Wadern', status: 'beta' },
    { name: 'Neunkirchen', status: 'beta' },
    { name: 'Saarlouis', status: 'beta' },
    { name: 'Saarpfalz-Kreis', status: 'beta' },
    { name: 'St. Wendel', status: 'beta' }
  ],
  'Sachsen': [
    { name: 'Chemnitz', status: 'live' },
    { name: 'Dresden', status: 'live' },
    { name: 'Leipzig', status: 'live' },
    { name: 'Erzgebirgskreis', status: 'beta' },
    { name: 'Mittelsachsen', status: 'beta' },
    { name: 'Vogtlandkreis', status: 'beta' },
    { name: 'Zwickau', status: 'beta' },
    { name: 'Dresden (Landkreis)', status: 'live' },
    { name: 'Bautzen', status: 'beta' },
    { name: 'Görlitz', status: 'beta' },
    { name: 'Meißen', status: 'beta' },
    { name: 'Sächsische Schweiz-Osterzgebirge', status: 'beta' },
    { name: 'Leipzig (Landkreis)', status: 'live' },
    { name: 'Nordsachsen', status: 'beta' }
  ],
  'Sachsen-Anhalt': [
    { name: 'Dessau-Roßlau', status: 'beta' },
    { name: 'Halle (Saale)', status: 'live' },
    { name: 'Magdeburg', status: 'live' },
    { name: 'Altmarkkreis Salzwedel', status: 'beta' },
    { name: 'Anhalt-Bitterfeld', status: 'beta' },
    { name: 'Börde', status: 'beta' },
    { name: 'Burgenlandkreis', status: 'beta' },
    { name: 'Harz', status: 'beta' },
    { name: 'Jerichower Land', status: 'beta' },
    { name: 'Mansfeld-Südharz', status: 'beta' },
    { name: 'Saalekreis', status: 'beta' },
    { name: 'Salzlandkreis', status: 'beta' },
    { name: 'Stendal', status: 'beta' },
    { name: 'Wittenberg', status: 'beta' }
  ],
  'Schleswig-Holstein': [
    { name: 'Flensburg', status: 'live' },
    { name: 'Kiel', status: 'live' },
    { name: 'Lübeck', status: 'live' },
    { name: 'Neumünster', status: 'beta' },
    { name: 'Dithmarschen', status: 'beta' },
    { name: 'Herzogtum Lauenburg', status: 'beta' },
    { name: 'Nordfriesland', status: 'beta' },
    { name: 'Ostholstein', status: 'live' },
    { name: 'Pinneberg', status: 'live' },
    { name: 'Plön', status: 'beta' },
    { name: 'Rendsburg-Eckernförde', status: 'beta' },
    { name: 'Schleswig-Flensburg', status: 'beta' },
    { name: 'Segeberg', status: 'beta' },
    { name: 'Steinburg', status: 'beta' },
    { name: 'Stormarn', status: 'live' }
  ],
  'Thüringen': [
    { name: 'Erfurt', status: 'live' },
    { name: 'Gera', status: 'beta' },
    { name: 'Jena', status: 'live' },
    { name: 'Suhl', status: 'beta' },
    { name: 'Weimar', status: 'live' },
    { name: 'Eisenach', status: 'beta' },
    { name: 'Eichsfeld', status: 'beta' },
    { name: 'Nordhausen', status: 'beta' },
    { name: 'Wartburgkreis', status: 'beta' },
    { name: 'Unstrut-Hainich-Kreis', status: 'beta' },
    { name: 'Kyffhäuserkreis', status: 'beta' },
    { name: 'Schmalkalden-Meiningen', status: 'beta' },
    { name: 'Gotha', status: 'beta' },
    { name: 'Sömmerda', status: 'beta' },
    { name: 'Hildburghausen', status: 'beta' },
    { name: 'Ilm-Kreis', status: 'beta' },
    { name: 'Weimarer Land', status: 'beta' },
    { name: 'Sonneberg', status: 'beta' },
    { name: 'Saalfeld-Rudolstadt', status: 'beta' },
    { name: 'Saale-Holzland-Kreis', status: 'beta' },
    { name: 'Saale-Orla-Kreis', status: 'beta' },
    { name: 'Greiz', status: 'beta' },
    { name: 'Altenburger Land', status: 'beta' }
  ]
};

// Property types (Objektarten)
export const propertyTypes = [
  { value: 'ackerland', label: 'Ackerland' },
  { value: 'gruenland', label: 'Grünland' },
  { value: 'wald', label: 'Wald' },
  { value: 'sonderkulturen', label: 'Sonderkulturen (Hopfen, Obst, Spargel)' },
  { value: 'weinberg', label: 'Weinberg / Rebfläche' },
  { value: 'eigenjagd', label: 'Eigenjagd / Jagdrevier' },
  { value: 'oekopunkte', label: 'Ökopunkte / Ausgleichsfläche' },
  { value: 'energieflaeche', label: 'Fläche für Solar / Wind' },
  { value: 'biogasanlage', label: 'Biogasanlage' },
  { value: 'landwirtschaftliche_gebaeude', label: 'Landwirtschaftliche Gebäude' },
  { value: 'bauernhof', label: 'Bauernhof' }
];

// Lease status options
export const leaseStatusOptions = [
  { value: 'eigennutzung', label: 'Eigennutzung' },
  { value: 'verpachtet', label: 'Verpachtet' },
  { value: 'teilpachtet', label: 'Teilweise verpachtet' }
];

// Mock FAQ data - SEO optimized
export const faqData = [
  {
    question: 'Wie kann ich meine Agrarfläche kostenlos bewerten lassen?',
    answer: 'Bei AgrarKapital erhalten Sie eine kostenlose und unverbindliche Bewertung Ihrer Agrarfläche. Wir bewerten Ackerland, Wald und Grünland professionell nach aktuellen Marktstandards. Unsere Experten berücksichtigen dabei Faktoren wie Bodengüte, Lage, Größe und regionale Marktpreise. Die Bewertung erfolgt durch zertifizierte Sachverständige und ist völlig kostenfrei - Sie zahlen nur bei erfolgreichem Verkauf eine Maklerprovision.'
  },
  {
    question: 'Welche Unterlagen brauche ich für den Verkauf von Ackerland?',
    answer: 'Für den Verkauf von Ackerland benötigen Sie folgende Unterlagen: aktueller Grundbuchauszug, Flurkarte, Bodenbonitierung mit Ackerzahl, eventuelle Pachtverträge, Drainage- oder Bewässerungspläne falls vorhanden. Falls Sie Unterlagen nicht haben, unterstützen wir Sie beim Beschaffen aller erforderlichen Dokumente. Wichtig ist auch die Kenntnis über Belastungen wie Wegerechte oder Leitungsrechte.'
  },
  {
    question: 'Wie hoch sind die Maklerkosten beim Verkauf von Agrarflächen?',
    answer: 'Bei AgrarKapital verfolgen wir ein faires Provisionssystem: Reine Agrarflächen (Ackerland, Wald, Grünland) werden OHNE Käuferprovision angeboten - nur der Verkäufer trägt die Dienstleistungsgebühr von 3-5% für den bestmöglichen Verkaufspreis. Bei Flächen MIT Gebäuden (z.B. Bauernhöfe) wird die Provision gemäß Bestellerprinzip zwischen Käufer und Verkäufer geteilt. Diese Investition lohnt sich, da professionell vermarktete Flächen oft 10-20% höhere Preise erzielen. Bei uns gibt es keine Vorabkosten - Sie zahlen nur bei erfolgreichem Verkauf.'
  },
  {
    question: 'Kann ich verpachtetes Ackerland verkaufen?',
    answer: 'Ja, verpachtetes Ackerland kann verkauft werden. Der Pachtvertrag geht dabei auf den neuen Eigentümer über - das nennt man "Kauf bricht nicht Miete". Wichtig: Der Verkaufspreis berücksichtigt die bestehende Pacht. Läuft der Pachtvertrag bald aus, kann der Verkaufspreis höher sein. Wir prüfen alle Pachtverträge und beraten Sie über den optimalen Verkaufszeitpunkt.'
  },
  {
    question: 'Brauche ich eine Genehmigung für den Verkauf meiner Agrarfläche?',
    answer: 'In den meisten deutschen Bundesländern benötigen Sie eine Grundverkehrsgenehmigung nach dem Grundstückverkehrsgesetz. Diese erteilt das örtliche Landratsamt oder die Landwirtschaftsbehörde. Außerdem haben Gemeinden oft ein Vorkaufsrecht. Wir kümmern uns um alle Genehmigungsverfahren und stellen sicher, dass Ihr Verkauf rechtssicher abläuft. Der gesamte Prozess dauert meist 2-4 Monate.'
  },
  {
    question: 'Wie finde ich seriöse Käufer für meine Waldfläche?',
    answer: 'Seriöse Käufer für Waldflächen finden Sie über spezialisierte Makler wie AgrarKapital. Wir haben ein Netzwerk aus Privatwaldbesitzern, Forstbetrieben, Investoren und institutionellen Käufern. Jeder Käufer wird vorab auf Bonität geprüft. Typische Käufer sind Landwirte zur Betriebserweiterung, Kapitalanleger oder Naturliebhaber. Unser Netzwerk umfasst über 1.500 qualifizierte Interessenten deutschlandweit.'
  },
  {
    question: 'Was bestimmt den Preis von Grünland?',
    answer: 'Der Preis von Grünland hängt von mehreren Faktoren ab: Ertragsmesszahl (EMZ), Lage, Bewirtschaftbarkeit, Drainage, Hanglage und Erschließung. Auch die regionale Nachfrage spielt eine große Rolle - in Milchviehgebieten sind die Preise höher. Feuchtwiesen oder schwer zugängliche Flächen haben geringere Preise. Unsere Experten bewerten all diese Faktoren und ermitteln den aktuellen Marktwert für Ihr Grünland.'
  },
  {
    question: 'Wie lange dauert ein Agrarflächen-Verkauf?',
    answer: 'Ein Agrarflächen-Verkauf dauert typischerweise 3-6 Monate. Die Dauer hängt von Größe, Lage, Preis und Genehmigungsverfahren ab. Bei AgrarKapital verkürzen wir die Zeit durch professionelle Vermarktung und unser großes Käufernetzwerk. Kleinere Flächen (unter 5 ha) verkaufen sich oft schneller, große Flächen (über 20 ha) brauchen mehr Zeit. Wir informieren Sie wöchentlich über den aktuellen Stand.'
  },
  {
    question: 'Welche Steuern fallen beim Verkauf von Agrarflächen an?',
    answer: 'Die Besteuerung hängt von verschiedenen Faktoren ab: War die Fläche Privatvermögen oder Betriebsvermögen? Wie lange war sie in Ihrem Besitz? Bei Privatvermögen und einer Haltedauer über 10 Jahre ist der Verkauf meist steuerfrei. Bei Betriebsvermögen können Spekulationssteuer oder Betriebsaufgabegewinne anfallen. Wir empfehlen vor jedem Verkauf eine steuerliche Beratung durch einen Fachsteuerberater.'
  },
  {
    question: 'Kann ich nur Teilflächen meines Ackerlands verkaufen?',
    answer: 'Ja, Teilverkäufe sind möglich und oft sinnvoll. Große Ackerflächen können in mehrere Parzellen aufgeteilt werden - das ermöglicht verschiedene Käufergruppen und oft höhere Gesamterlöse. Wichtig: Jede Teilfläche muss im Grundbuch eigenständig ausgewiesen werden. Wir prüfen vorab die Teilbarkeit und erstellen einen optimalen Aufteilungsplan für maximale Verkaufserlöse.'
  }
];

// Mock analytics event names
export const analyticsEvents = {
  LP_VIEW: 'lp_view',
  HERO_CTA_CLICK: 'hero_cta_click',
  FORM_STEP_VIEW: 'form_step_view',
  FORM_SUBMIT: 'form_submit',
  CONSENT_GRANTED: 'consent_granted',
  PHONE_CLICK: 'phone_click',
  SECONDARY_CTA_CLICK: 'secondary_cta_click',
  FAQ_EXPAND: 'faq_expand',
  NEWSLETTER_SUBSCRIBE: 'newsletter_subscribe',
  BUYER_INTEREST_CLICK: 'buyer_interest_click',
  BUYER_REGISTRATION_SUBMIT: 'buyer_registration_submit',
  CATEGORY_PAGE_CLICK: 'category_page_click',
  CALLBACK_REQUEST: 'callback_request',
  CONTACT_FORM_SUBMIT: 'contact_form_submit',
  VIDEO_CLICK: 'video_click',
  TOOL_CLICK: 'tool_click',
  SOCIAL_CLICK: 'social_click'
};

export const submitContactForm = async (contactData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/callbacks`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: `${contactData.vorname} ${contactData.nachname}`,
        telefon: contactData.telefon || 'Nicht angegeben',
        email: contactData.email,
        rueckrufzeit: 'Per E-Mail kontaktiert',
        nachricht: `Betreff: ${contactData.betreff || 'Kontaktanfrage'}\n\nNachricht: ${contactData.nachricht}`,
        datenschutz: contactData.datenschutz
      })
    });
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    return {
      success: true,
      message: 'Vielen Dank! Wir haben Ihre Kontaktanfrage erhalten und melden uns innerhalb von 24 Stunden.'
    };
  } catch (error) {
    console.error('Contact form submission error:', error);
    return {
      success: false,
      message: 'Fehler beim Senden der Nachricht. Rufen Sie uns direkt an: 08161/18505-50'
    };
  }
};
// Mock form submission handlers - will be replaced with real API calls
export const submitLeadForm = async (formData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/leads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    const result = await response.json();
    
    // ✅ ANALYTICS: Track Lead Submission
    trackEvent('lead_submission', {
      objektart: formData.objektart,
      bundesland: formData.bundesland,
      landkreis: formData.landkreis,
      groesse: formData.groesse,
      value: 100  // Lead-Wert
    });
    
    // ✅ FACEBOOK PIXEL: Lead Event
    if (window.fbq) {
      window.fbq('track', 'Lead', {
        content_name: 'Bewertungsanfrage',
        content_category: formData.objektart,
        value: 100,
        currency: 'EUR'
      });
    }
    
    return {
      success: true,
      message: 'Vielen Dank! Wir haben Ihre Bewertungsanfrage erhalten und melden uns innerhalb von 24 Stunden bei Ihnen.'
    };
  } catch (error) {
    console.error('Lead form submission error:', error);
    return {
      success: false,
      message: 'Es gab einen Fehler beim Senden. Bitte versuchen Sie es erneut oder rufen Sie uns an: 08161/18505-50'
    };
  }
};

export const submitCallbackForm = async (callbackData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/callbacks`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(callbackData)
    });
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    // ✅ ANALYTICS: Track Callback Request
    trackEvent('callback_request', {
      name: callbackData.name,
      value: 30
    });
    
    // ✅ FACEBOOK PIXEL: Contact Event
    if (window.fbq) {
      window.fbq('track', 'Contact');
    }
    
    return {
      success: true,
      message: 'Vielen Dank! Wir rufen Sie innerhalb der nächsten 24 Stunden zurück.'
    };
  } catch (error) {
    console.error('Callback form submission error:', error);
    return {
      success: false,
      message: 'Fehler beim Senden. Rufen Sie uns direkt an: 08161/18505-50'
    };
  }
};

export const submitNewsletter = async (newsletterData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newsletterData)
    });
    
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    // ✅ ANALYTICS: Track Newsletter Signup  
    trackEvent('newsletter_signup', {
      name: newsletterData.name,
      value: 20
    });
    
    // ✅ FACEBOOK PIXEL: Subscribe Event
    if (window.fbq) {
      window.fbq('track', 'Subscribe');
    }
    
    return {
      success: true,
      message: 'Vielen Dank! Sie erhalten in Kürze eine Bestätigung per E-Mail.'
    };
  } catch (error) {
    console.error('Newsletter submission error:', error);
    return {
      success: false,
      message: 'Fehler bei der Anmeldung. Versuchen Sie es erneut.'
    };
  }
};

export const submitBuyerProfile = async (buyerData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/buyers`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(buyerData)
    });
    
    // Besseres Error Handling
    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      const errorMessage = errorData?.detail || `Server-Fehler: ${response.status}`;
      console.error('Suchprofil API Error:', errorMessage, errorData);
      throw new Error(errorMessage);
    }
    
    const data = await response.json();
    
    // ✅ ANALYTICS: Track Suchprofil Creation
    trackEvent('profile_created', {
      bundesland: buyerData.bundesland,
      flaechenarten: buyerData.flächenarten ? buyerData.flächenarten.join(',') : '',
      value: 50
    });
    
    // ✅ FACEBOOK PIXEL: CompleteRegistration Event
    if (window.fbq) {
      window.fbq('track', 'CompleteRegistration', {
        content_name: 'Suchprofil',
        value: 50,
        currency: 'EUR'
      });
    }
    
    return {
      success: true,
      message: data.message || 'Vielen Dank! Ihr Suchprofil wurde erstellt. Wir melden uns bei passenden Angeboten.'
    };
  } catch (error) {
    console.error('Buyer profile submission error:', error);
    return {
      success: false,
      message: error.message || 'Fehler beim Erstellen des Suchprofils. Rufen Sie uns an: 08161/18505-50'
    };
  }
};
// Analytics tracking with Google Analytics integration
export const trackEvent = (eventName, properties = {}) => {
  console.log(`Analytics Event: ${eventName}`, properties);
  
  // Send to Google Analytics if consent given
  if (window.gtag && localStorage.getItem('agrarkapital_cookie_consent')) {
    const consent = JSON.parse(localStorage.getItem('agrarkapital_cookie_consent'));
    if (consent.analytics) {
      window.gtag('event', eventName, {
        event_category: 'AgrarKapital',
        event_label: properties.location || 'unknown',
        value: properties.value || 1,
        custom_parameters: properties
      });
    }
  }
  
  // Send to Facebook Pixel if consent given
  if (window.fbq && localStorage.getItem('agrarkapital_cookie_consent')) {
    const consent = JSON.parse(localStorage.getItem('agrarkapital_cookie_consent'));
    if (consent.marketing) {
      window.fbq('trackCustom', eventName, properties);
    }
  }
};

// Telefon-Click Tracking (für SEA Conversion)
export const trackPhoneClick = (location = 'unknown') => {
  // Standard Event Tracking
  trackEvent('phone_click', { location });
  
  // SEA Conversion Events
  if (window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-XXXXXXXXX/XXXXX', // Wird vom SEA-Spezialisten eingefügt
      'value': 50.0,
      'currency': 'EUR'
    });
  }
  
  // Facebook Lead Event
  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: 'Phone Click',
      content_category: location,
      value: 50.0,
      currency: 'EUR'
    });
  }
};